"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardLiterPerSecond = exports.StandardCubicMeterPerSecond = exports.StandardCubicFeetPerMinute = exports.StandardCubicMeterPerHour = exports.GrainPerSecond = exports.GrainPerHour = exports.PoundLbPerSecond = exports.PoundLbPerHour = exports.SlugPerHour = exports.SlugPerSecond = exports.KilogramPerHour = exports.GramPerHour = exports.GramPerSecond = exports.KilogramPerSecond = void 0;
var uom_1 = require("uom");
exports.KilogramPerSecond = uom_1.UnitFormat.createUnitFormat("kg/s", 2);
exports.GramPerSecond = uom_1.UnitFormat.createUnitFormat("g/s", 2);
exports.GramPerHour = uom_1.UnitFormat.createUnitFormat("g/h", 2);
exports.KilogramPerHour = uom_1.UnitFormat.createUnitFormat("kg/h", 2);
exports.SlugPerSecond = uom_1.UnitFormat.createUnitFormat("slug/s", 2);
exports.SlugPerHour = uom_1.UnitFormat.createUnitFormat("slug/h", 2);
exports.PoundLbPerHour = uom_1.UnitFormat.createUnitFormat("lb/h", 1);
exports.PoundLbPerSecond = uom_1.UnitFormat.createUnitFormat("lb/s", 1);
exports.GrainPerHour = uom_1.UnitFormat.createUnitFormat("gr/h", 2);
exports.GrainPerSecond = uom_1.UnitFormat.createUnitFormat("gr/s", 2);
exports.StandardCubicMeterPerHour = uom_1.UnitFormat.createUnitFormat("Sm³/h", 0);
exports.StandardCubicFeetPerMinute = uom_1.UnitFormat.createUnitFormat("SCFM", 0);
exports.StandardCubicMeterPerSecond = uom_1.UnitFormat.createUnitFormat("Sm³/s", 2);
exports.StandardLiterPerSecond = uom_1.UnitFormat.createUnitFormat("Sl/s", 2);
//# sourceMappingURL=mass-flow-format.js.map